
  
<script>
  import Layout from "../../layouts/main";
  import CampaignList from "@/router/views/campaign/campaign-list";


  export default {
    name: 'company',
    components: {Layout,CampaignList},
    data() {
      return {
       
      };
    },
  
    mounted() {
    },
  
    methods: {
  
    },
  };
</script>

<template>
    <Layout>
        <div class="row pt-0 pr-sm-5 pl-sm-5">
        <div class="col-lg-12">
            <div class="card">
            <div class="card-body">
                

                <CampaignList/>
               
            </div>
            </div>
        </div>
        </div>
    </Layout>
  </template>
  